import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { RenderIf } from "../../../utils/RenderIf";

export default function HeaderSection({ S, data, doc_type }) {
    return (
        <View style={S.header}>

            {/* LOGO IZQUIERDA */}

             <View style={S.imageContainer}>
                <Image
                    src={data.logo}
                    style={S.imageFit}
                />
            </View>


            {/* TITULO CENTRADO REAL */}
            <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                {/* <Text style={[S.brandTitle, { textAlign: "center" }]}>
          Factura
        </Text> */}



                 <Text style={[S.brandTitle, { textAlign: "center" }]}>
                    <RenderIf isTrue={doc_type === "quote"}>
                        COTIZACION:
                    </RenderIf>

                    <RenderIf isTrue={doc_type === "invoice"}>
                        Comprobante Auxiliar de Factura Electrónica
                    </RenderIf>

                    <RenderIf isTrue={doc_type === "credit_note"}>
                        Comprobante Auxiliar de Nota de credito
                    </RenderIf>
                </Text>
                <Text style={[S.brandTitle, { textAlign: "center" }]}>
                    <RenderIf isTrue={doc_type === "quote"}>
                      {data.transaction_code ? `#${data.transaction_code}` : ''}
                    </RenderIf>

                    <RenderIf isTrue={doc_type === 'invoice'}>
                        Factura de Operación Interna: {data.transaction_code ? `#${data.transaction_code}` : ''}
                    </RenderIf>

                    <RenderIf isTrue={doc_type === 'credit_note'}>
                        Nota de credito referenta a una o varias FE: {data.transaction_code ? `#${data.transaction_code}` : ''}
                    </RenderIf>
                </Text>
            </View>

        </View>
    );
}